import React from 'react';
import { NotesContainer, MainContainerItems } from 'src/common/components/reviewAndSubmitNotes/reviewAndSubmitNotes.styled.jsx';
import { Subtitle, NoteDetails, Edit, Del } from './CustomerCareNotes.styled';
import EditCard from './EditCard.jsx';
import {
    checkImpersonationActive,
    checkProxyActive,
    convertTime24To12,
    logErrorToConsole,
} from 'src/utils/util';
import {
    getDisplayDate,
} from 'src/utils/dateUtils';
import MDIedit from 'src/assets/images/MDIedit.svg';
import MDIEditDisable from 'src/assets/images/MDIEditDisable.svg';
import DeleteIcon from 'src/assets/images/DeleteIcon.svg';
import { useSelector } from 'react-redux';
import { FONT_FAMILY_DEMI } from 'src/styles/fonts/MCFontConstants';
import { useTranslation } from 'react-i18next';

const NotesTwoContainer = ({
    notesTwoDisplay,
    editNoteTwo,
    editNoteTwoValue,
    setEditNoteTwoValue,
    handleEditTwo,
    handleDelete,
    setNotesCount,
    handleCloseEditTwo,
    handleEditSaveTwo,
    setEditNoteTwo,
    setShowSuccessMessageTwo,
    CloseBlue,
    TickBlue
}) => {
    const { t } = useTranslation();
    const { displayName } = useSelector((state) => ({
        notesData: state.HeaderNotesReducer,
        displayName: state.loginReducer.hybrisUserDetails.displayName,
    }));
    return (
        <>
            <NotesContainer margin="15px 0 0 -20px">
                {notesTwoDisplay.length > 0
                    ? notesTwoDisplay &&
                    notesTwoDisplay.map((item, index) => (
                        <React.Fragment key={index}>
                            <MainContainerItems
                                setMarginBottom={true}
                                setWidth="100%"
                                mbSetWidth="107%"
                                borderLeft={
                                    item.isNew ? '2px solid #12C8F7' : 'none'
                                }
                                paddingLeft="20px"
                                marginLeft="-20px"
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                   <Subtitle
                                        showAstrisk={false}
                                        fontSize="13px"
                                    >
                                        <b
                                            style={{
                                                marginRight: '10px',
                                            }}
                                        >
                                            {' '}
                                            {t(
                                                'equity.surgery.createdBy'
                                            )}{' '}
                                            {checkImpersonationActive() ||
                                                checkProxyActive()
                                                ? sessionStorage.getItem(
                                                    'ProxyUser'
                                                )
                                                : (item.userName
                                                    ? item.userName
                                                    : displayName) ||
                                                ''}{' '}
                                        </b>{' '}
                                    </Subtitle>
                                    {item?.isNew ? (
                                        <div
                                            style={{
                                                display: 'flex',
                                                gap: '10px',
                                            }}
                                        >
                                            <Edit>
                                                <img
                                                    src={
                                                        editNoteTwo === index
                                                            ? MDIEditDisable
                                                            : MDIedit
                                                    }
                                                    alt="Edit note"
                                                    onClick={() =>
                                                        handleEditTwo(
                                                            item,
                                                            index
                                                        )
                                                    }
                                                />
                                            </Edit>
                                            <Del>
                                                <img
                                                    src={DeleteIcon}
                                                    onClick={() => {
                                                        handleDelete(
                                                            item,
                                                            index,
                                                            'notes2'
                                                        );
                                                        setNotesCount(
                                                            (prev) => prev - 1
                                                        );
                                                    }}
                                                />
                                            </Del>
                                        </div>
                                    ) : item?.isDelete || item?.isEdit ? (
                                        <div
                                            style={{
                                                display: 'flex',
                                                gap: '10px',
                                            }}
                                        >
                                            {item?.isEdit && (
                                                <Edit>
                                                    <img
                                                        src={
                                                            editNoteTwo ===
                                                                index
                                                                ? MDIEditDisable
                                                                : MDIedit
                                                        }
                                                        alt="Edit note"
                                                        onClick={() =>
                                                            handleEditTwo(
                                                                item,
                                                                index
                                                            )
                                                        }
                                                    />
                                                </Edit>
                                            )}
                                            {item?.isDelete && (
                                                <Del>
                                                    <img
                                                        src={DeleteIcon}
                                                        onClick={() => {
                                                            handleDelete(
                                                                item,
                                                                index,
                                                                'notes2'
                                                            );
                                                            setNotesCount(
                                                                (prev) =>
                                                                    prev - 1
                                                            );
                                                        }}
                                                    />
                                                </Del>
                                            )}
                                        </div>
                                    ) : null}
                                </div>
                                <Subtitle>
                                    {getDisplayDate(item.creationDate)}
                                    {' | '}
                                    {convertTime24To12(
                                        new Date(item.creationDate)
                                    )}{' '}
                                </Subtitle>
                                {editNoteTwo === index && (
                                    <>
                                        <EditCard
                                            value={
                                                editNoteTwoValue ?? item.note
                                            }
                                            editTextHandler={(e) => {
                                                setEditNoteTwoValue(
                                                    e.target.value
                                                );
                                            }}
                                            CloseBlue={CloseBlue}
                                            closeEditHandler={
                                                handleCloseEditTwo
                                            }
                                            TickBlue={TickBlue}
                                            blueTickHandler={() => {
                                                const isEmptyValue =
                                                    !editNoteTwoValue ||
                                                    editNoteTwoValue.trim() ===
                                                    '';

                                                handleEditSaveTwo(index);
                                                setEditNoteTwoValue(null);
                                                setEditNoteTwo(null);

                                                if (!isEmptyValue) {
                                                    setShowSuccessMessageTwo(
                                                        true
                                                    );
                                                    setTimeout(() => {
                                                        try {
                                                            setShowSuccessMessageTwo(
                                                                false
                                                            );
                                                        }
                                                        catch (error) {
                                                            logErrorToConsole(error);
                                                        }
                                                    }, 4000);
                                                }
                                            }}
                                        />
                                    </>
                                )}
                                {item.typeOfNote === 'CaseNotes' ? (
                                    <>
                                        {item.updatedSurgeryDate && (
                                            <div
                                                style={{
                                                    fontFamily:
                                                        FONT_FAMILY_DEMI,
                                                    color: '#202124',
                                                    fontSize: '14px',
                                                    marginBottom: '8px',
                                                }}
                                            >
                                                {item.updatedSurgeryDate}
                                            </div>
                                        )}

                                        <ol
                                            type="a"
                                            style={{
                                                paddingLeft: '16px',
                                                color: '#202124',
                                                fontFamily:
                                                    'AvenirNextWorld Regular',
                                                wordBreak: 'break-all',
                                                margin: '0',
                                                fontSize: '15px',
                                            }}
                                        >
                                            {item.note
                                                .split(';')
                                                .map((element, index) => {
                                                    return (
                                                        <li key={index}>
                                                            {element}
                                                        </li>
                                                    );
                                                })}
                                        </ol>
                                    </>
                                ) : (
                                    editNoteTwo !== index && (
                                        <NoteDetails className="customer-care-note-two-text-dt-mask" hideBorder={true}>
                                            {item.note}
                                        </NoteDetails>
                                    )
                                )}
                            </MainContainerItems>
                        </React.Fragment>
                    ))
                    : null}
            </NotesContainer>
        </>
    );
};

export default NotesTwoContainer;